module.exports = __webpack_public_path__ + "img/vertical_6_6_7042.914177ab.png";